import { matchesRoute } from "@/utils/common_functions";
export const Routes = {
  INDEX: '/',
  HOME: '/home',
  SIGNUP: '/signup',
  SPECIALIST_SIGNUP: '/specialist-signup',
  LOGIN: '/login',
  VERIFY_OTP: '/verify-otp',
  VERIFY_MFA: '/verify-mfa',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  ADMIN: '/admins',
  RBAC: '/access-control',
  AUDIT_LOG: '/audit-log',
  SETTINGS: '/settings',
  SPECIALISTS: '/specialist',
  FAVORITES: '/favorites',
  SPECIALIST_DISPLAY: '/specialist-display',
  SPECIALIST_PROFILE_VIEW: '/specialist/profile/:id',
  HELP: '/help',
  ACTIVITY: '/activity',
  CONSULTATION: '/consultation',
  CONSULTATION_SUMMARY: '/consultation/summary/:id',
  PATIENTS: '/patients',
  PATIENT_DISPLAY: '/patient-settings',
  EARNINGS: '/earnings',
  RATINGS: '/ratings',
  SUPPORT_TICKETS: '/support-tickets',
  HOSPITAL_PROFILE_VIEW: '/hospital/profile/:id',
  SPECIALIST_ADMIN_ONBOARDING_SPECIALIST: '/specialist/onboarding',
  SPECIALIST_ADMIN_PROFILE_DETAIL: '/specialist/onboarding/profile/:id',
  PATIENT_PAYMENTS: '/finance/patient-payments',
  SPECIALIST_PAYOUTS: '/finance/manage-payouts',
  TERMS: "/terms-and-conditions",
  PRIVACY: "/security-policy"
} as const;


export const DashboardRouteHeaderTitles = {
  [Routes.DASHBOARD]: 'Dashboard',
  [Routes.SUPPORT_TICKETS]: 'Support Tickets',
  [Routes.ADMIN]: 'Admin',
  [Routes.RBAC]: 'Access Control',
  [Routes.AUDIT_LOG]: 'Audit Log',
  [Routes.PROFILE]: 'Profile',
  [Routes.SPECIALISTS]: 'Specialists',
  [Routes.FAVORITES]: 'Favorites',
  [Routes.SPECIALIST_DISPLAY]: 'Specialists Display',
  [Routes.CONSULTATION]: 'Consultations',
  [Routes.ACTIVITY]: 'Activity',
  [Routes.SETTINGS]: 'Settings',
  [Routes.HELP]: 'Help',
  [Routes.PATIENTS]: 'Patients',
  [Routes.PATIENT_DISPLAY]: 'Patient Settings',
  [Routes.EARNINGS]: 'Payments',
  [Routes.CONSULTATION_SUMMARY]: 'Case Summary',
  [Routes.SPECIALIST_PROFILE_VIEW]: 'View Profile',
  [Routes.HOSPITAL_PROFILE_VIEW]: 'Hospital Details',
  [Routes.PATIENT_PAYMENTS]: 'Patient Payments',
  [Routes.SPECIALIST_PAYOUTS]: 'Manage Payouts',
  [Routes.SPECIALIST_ADMIN_ONBOARDING_SPECIALIST]: 'Onboarding',
  [Routes.SPECIALIST_ADMIN_PROFILE_DETAIL]: 'Specialist Profile',
  [Routes.TERMS]: 'Terms and Conditions',
  [Routes.PRIVACY]: 'Security Policy',
} as const;


export type RouteKeys = keyof typeof Routes;
export const LinkedRoutes: Record<string, string> = {
  [Routes.HOSPITAL_PROFILE_VIEW]: Routes.SPECIALISTS,
};


export function getNormalizedRoute(route: string): string | null {
  for (let key in Routes){
    if (matchesRoute(route, Routes[key as keyof typeof Routes])) {
      return Routes[key as keyof typeof Routes];
    }
  }
  return null;
}